<template>
  <div class= "about-page">

   <div class = "img-about-header">
     <p class = "aboutss" style="font-size: 32px !important;  !important"> About Xrubicon</p>
      <p class = "aboutss">
        Xrubicon solutions limited is a software solution entity and a subsidiary of contact solutions limited a foremost call center solution company in Nigeria. 
        It is established to help companies reimagine their business by building impactful digital engineering solutions powered by the latest technologies.
        </p>
    </div>
    <div style = "padding: 100px">
    <div >
        
            <div class="container-fluid" style = "padding: 0 130px 0 130px;">
                      <div class="first-row row">
                        <div class="col">
                            <div class="row">
                              <div class="col-lg-6 col-md-1 col-sm-6 py-3">
                                    <div class="mission">
        <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
          Our Mission
        </p>
        <p id = "all-text">
          To deploy social impact software solutions across social economic sphere.
          </p>                                    </div>
                              </div>
                              <div class="col-lg-6 col-md-1 col-sm-6 py-3">
                               <div class="mission">
        <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
          Our Vision
        </p>
        <p id = "all-text">
To become a global technology company that offers end-to-end software solutions across social economic space at a click.          </p>                                    </div>
                          </div>
              
                
                            </div>
                        </div>
                      
                      </div>
                    </div> 
      </div>



  <!-- Our Core Values -->

<div style = "padding: 0 140px 0 140px">

   <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
          Our Core Values
        </p>

 <section class="brand-area py-3">
                    <div class="container-fluid">
                      <div class="first-row row">
                        <div class="col">
                            <div class="row">
                              <div class="col-lg-4 col-md-6 col-sm-6 mission">
                                    <div class="single-brand">
                                      <img src="../assets/img/social-impact.png" alt="Social Impact" width = 150px height="90px">
                                      <p id = "all-text"> Focus on social impact </p>
                                    </div>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-6 mission">
                                <div class="single-brand">
                                  <img src="../assets/img/openness.png" alt="Openness" width = 150px height = 90px >
                                  <p id = "all-text"> Openness </p>
                                </div>
                          </div>
                          <div class="col-lg-4 col-md-6 col-sm-6 mission">
                            <div class="single-brand">
                              <img src="../assets/img/collaboration.png" alt="Collaboration"  width = 150px>
                                                                    <p id = "all-text" > Collaboration </p>

                            </div>
                      </div>
                
                            </div>
                        </div>
                      
                      </div>
                      <div class="first-row row py-3 px-5">
                        <div class="col">
                            <div class="row">
                              <div class="col-lg-6 col-md-6 col-sm-6 mission impos">
                                    <div class="single-brand">
                                      <img src="../assets/img/innovation.png" alt="Innovation" width = 150px>
                                         <p id = "all-text"> Innovation </p>

                                    </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 mission impos">
                                <div class="single-brand">
                                  <img src="../assets/img/ownership.png" alt="Ownership" width = 150px >
                                                                        <p id = "all-text"> Ownership </p>

                                </div>
                          </div>
                
                            </div>
                        </div>
                      
                      </div>
                    </div>
                  </section> 

  </div>

  <!-- End Our Core Values -->


  <!-- Our Business -->

  <div class="container-fluid">
      <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
          Our Business
        </p>
                      <div class="first-row row">
                        <div class="col">
                            <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-6 py-3">
                                    <div class="business">
       
        <p  id = "all-text">
          Web Software
          </p>                                    </div>
                              </div>
                              <div class="col-lg-3 col-md-3 col-sm-6 py-3">
                               <div class="business">
    
        <p  id = "all-text">
          Mobile Software
     </p>                                    </div>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 py-3">
                                    <div class="business">
    
        <p id = "all-text" >
          Mapping and Navigation
          </p>                                    </div>
                              </div>
                              <div class="col-lg-3 col-md-3 col-sm-6 py-3">
                                    <div class="business">
     
        <p id = "all-text" >
          GIS Software
          </p>                                    </div>
                              </div>
              
                
                            </div>
                        </div>
                      
                      </div>
                           <div class="first-row row">
                        <div class="col">
                            <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-6 py-3">
                                    <div class="business">
       
        <p id = "all-text" > 
          Server Development DevOps
          </p>                                    </div>
                              </div>
                              <div class="col-lg-3 col-md-3 col-sm-6 py-3">
                               <div class="business">
    
        <p id = "all-text" >
          Hardware Ecosystems
     </p>                                    </div>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 py-3">
                                    <div class="business">
    
        <p id = "all-text">
          Business Development
          </p>                                    </div>
                              </div>
                              <div class="col-lg-3 col-md-3 col-sm-6 py-3">
                                    <div class="business">
     
        <p id = "all-text" >
          System Software Development
          </p>                                    </div>
                              </div>
              
                
                            </div>
                        </div>
                      
                      </div>
                    </div> 


  <!-- End Our Business -->

  <!-- Our Concept -->
  <div class = "our-concept">

   <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
          Our Concept
        </p>
        <p style = "color: #2D2D2D">
          Is to simplify business processes and create a social impact solution for various market setup
         </p> 
  </div>
  <!-- End Our Concept -->

  <!-- Our Goals -->
  <div class = "py-3 our-concept"> 

    <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
          Our Goals
        </p>
        <p style = "color: #2D2D2D" >
          <i class="fa fa-check-circle-o" aria-hidden="true"></i>

Is to explore the exponential growth in ICT across the country
        </p>
        <p style = "color: #2D2D2D">
          <i class="fa fa-check-circle-o" aria-hidden="true"></i>

  Fuel business growth by encouraging smart transaction
        </p>
        <p style = "color: #2D2D2D">
          <i class="fa fa-check-circle-o" aria-hidden="true"></i>

  Turn data provision and management into viable business solution.
         </p> 

  </div>
  <!-- End Our Goals-->

  <!-- Key to Success -->

  <div class = "py-3 our-concept"> 

    <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">

          Our Key to Success
        </p>
       <div id = " success para" style = "color: #2D2D2D">

        
        <p style = "color: #2D2D2D"> 
          <i class="fa fa-check-circle-o" aria-hidden="true"></i>

     Deploying the best user interface and experience software application       
 </p>
        <p style = "color: #2D2D2D">
          <i class="fa fa-check-circle-o" aria-hidden="true"></i>

          Consistent system optimization
        </p>
        <p style = "color: #2D2D2D">
          <i class="fa fa-check-circle-o" aria-hidden="true"></i>

          Excellent customer service
         </p> 
         <p style = "color: #2D2D2D">
           <i class="fa fa-check-circle-o" aria-hidden="true"></i>

           Maintain vertical & horizontal stakeholders’ relationship
           </p>
           <p style = "color: #2D2D2D">
             <i class="fa fa-check-circle-o" aria-hidden="true"></i>

             Deployment of entire eco-system solutions
             </p>
             <p style = "color: #2D2D2D">
               <i class="fa fa-check-circle-o" aria-hidden="true"></i>

               Creating online & physical image
               </p>
                </div>

  </div>



  <!-- End Key to Success -->


  <!-- Get In Touch -->

       <div class="first-row row">
                        <div class="col">
                            <div class="row">
                              <div class="col-lg-12 col-md-6 col-sm-6 py-3">
                                    <div class="touch"> 
        <p style = "color: #2D2D2D">
          At XRubicon Solutions we help business build an intelligently designed digital future.
        </p>
     
         <p style = "color: #2D2D2D">
        Tell us about your idea, and we’ll offer the most fitting technological solution.
           </p>  

             <a class="btn btn-new btn-xl js-scroll-trigger" href="#services"
                style = "background-color: #A31B1F ; color : #FFFFFF"
                
                >Get in touch</a
              > 
        
                                       
          </div>
                              </div>
                             
                          
                
                            </div>
                        </div>
                      
                      </div>



    <!-- End Get In Touch -->
</div>

</div>
</template>

<style>

#all-text {
    color: rgb(33, 37, 41) !important;
}

.about-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.about{
display: flex;
  align-items: center;
  justify-content: center;
  text-align: justify;
font: 24px/35px  !important;
width: 50vw;
letter-spacing: 0px;
color: #FFFFFF;
opacity: 1;
}
i {
  color: #A31B1F;
}
#para {
  color: #2D2D2D
}
.brand-area {
        display: flex;
        justify-content: center;
    }
.img-about-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 45px;
  justify-content: center;
  align-items: center;
  height: 600px;
  background-attachment: fixed;
  background-position: center; 
  position: relative;
  background-repeat: no-repeat;
  background: linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7) ), url('../assets/img/About.png'); 
      background-size: cover;

}

.mission{
  width: 450px;
  padding: 15px;
  color: #2D2D2D;
  font-size: 16px;
  height:   200px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
display: flex;
align-items: center;
flex-direction: column;
justify-content: center;

}
.business{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  padding: 70px;
  color: #2D2D2D;
  font-size: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
height: 185px;
text-align: center;

}

.touch{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px;
  width: 90vw;
  color: #2D2D2D;
  font-size: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
height: 185px;
text-align: center;

}
.success {
  display: flex;
  justify-content: center;
  text-align:justify
}

footer {
  width:100vw
}
body {
  background: black;
}
</style>

<script>
    import router from '../router'

    export default {
        name: 'About',
        methods: {
            navigate() {
                router.push({ name: "About" });
            }
        }
    }
</script>

